// Iter 913 (Kamel) — ⚠️ après tout envoi d'e-mail (lien d'accès, confirmation de RDV, place de bus…) : penser aux indésirables / spam
import React from 'react';

export default function SpamNotice({ quoi = 'cet e-mail', compact = false, testId = 'spam-notice' }) {
  return (
    <div className={`bg-amber-100 border-2 border-amber-300 rounded-xl text-amber-900 ${compact ? 'px-3 py-2 text-xs' : 'px-3 py-2.5 text-sm'} leading-relaxed`} data-testid={testId}>
      <p className="font-bold">⚠️ Vous ne voyez pas {quoi} ?</p>
      <p className={compact ? '' : 'text-xs mt-0.5'}>
        Regardez dans votre dossier <strong>« Courrier indésirable »</strong> (aussi appelé <strong>« Spam »</strong> ou « Indésirables ») : Orange, Yahoo, Hotmail/Outlook et Gmail y rangent parfois nos messages.
        Si vous l'y trouvez, marquez-le <strong>« Pas un spam »</strong> pour recevoir les suivants normalement.
      </p>
    </div>
  );
}
